export const isColorAmenityIcon = (name = "") =>
  /pure\s*veg/i.test(String(name));

export const amenityIconFilterClass = (name) =>
  isColorAmenityIcon(name) ? "" : "brightness-0";
